<template>
  <div>
    <b-row>
      <!-- Left Section: Tables and Chart -->
      <b-col
        cols="12"
        md="4"
      >
        <DashboardActivityLog
          v-if="$permissionAbility(OUTREACH_DASHBOARD_ACTIVITY_LOG, permissions)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BButtonToolbar,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormSelect,
  BLink,
  BListGroup,
  BListGroupItem,
  BModal,
  BPagination,
  BRow,
  BSpinner, BTab, BTabs,
  VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'

import LvColorPicker from 'lightvue/color-picker'
import { milestoneTaskBoardStatusConstants } from '@/helpers/constant/milestoneTaskBoardStatusConstant.js'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import flatPickr from 'vue-flatpickr-component'
import {
  milestoneBoardTypeConstants as milestoneBoardTypeConstant,
} from '@/helpers/constant/milestoneBoardTypeConstant.js'
import UserSelect from '@/layouts/components/UserSelect.vue'
import UserCard from '@/layouts/components/UserCard.vue'
import { formatDateRange } from '@/helpers/helpers'
import {
  required, max, size, ext, max_value, min_value,
} from '@validations'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import BCardCode from '@core/components/b-card-code'
import DashboardActivityLog from '@/views/admin/outreach-management/Dashboard/Component/DashboardActivityLog.vue'
import TodayAssignedTable from '@/views/admin/task-management/Dashboard/Component/TodayAssignedTable.vue'
import WeeklyDueTasks from '@/views/admin/task-management/Dashboard/Component/WeeklyDueTasksTable.vue'
import DashboardStatisticsView from '@/views/admin/task-management/Dashboard/Component/DashboardStatisticsView.vue'
import TaskByAssigneeChart from '@/views/admin/task-management/Dashboard/Component/TaskByAssigneeChart.vue'
import {
  OUTREACH_DASHBOARD_ACCESS,
  OUTREACH_DASHBOARD_ACTIVITY_LOG,
} from '@/helpers/permissionsConstant'
import TaskByPhaseChart from '@/views/admin/task-management/Dashboard/Component/TaskByPhaseChart.vue'

export default {
  name: 'OutreachDashboard',
  components: {
    TaskByPhaseChart,
    TaskByAssigneeChart,
    Chart,
    DashboardStatisticsView,
    WeeklyDueTasks,
    TodayAssignedTable,
    DashboardActivityLog,
    BTabs,
    BCardCode,
    BTab,
    AppTimeline,
    AppTimelineItem,
    UserCard,
    UserSelect,
    LvColorPicker,
    BForm,
    BRow,
    BCol,
    BButton,
    BButtonGroup,
    BButtonToolbar,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BBadge,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BLink,
    BListGroup,
    BListGroupItem,
    BFormDatepicker,
    BFormRadio,
    BFormCheckbox,
    flatPickr,
    BCardActions,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  computed: {
    ...mapGetters({
      permissions: 'userModule/getPermissions',
    }),
  },
  data() {
    return {
      OUTREACH_DASHBOARD_ACTIVITY_LOG,
      OUTREACH_DASHBOARD_ACCESS,

      viewAs: 'employee',

    }
  },

  async created() {
    try {
      await this.loadItems()
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error',
          icon: 'BellIcon',
          variant: 'danger',
          text: error?.response?.data?.message,
        },
      })
    }
  },

  methods: {

    async loadItems() {
      try {
        // get all members
        const allMembers = await this.getAllMembers()

        this.allMemberIdOptions = allMembers?.data?.data?.map(item => ({
          avatar: item?.avatar,
          name: item?.name,
          email: item?.email,
          mobile: item?.mobile,
          employee_number: item?.employee_number,
          id: item?.id,
          departmentId: item?.department_id,
          inactive: !item?.status,
        }))

        const statistics = await this.$api.get(
          'api/tasks-dashboard/statistics',
        )

        this.statistics = statistics?.data
      } catch (error) {
        const message = error?.response?.data?.message
            || error.message
            || 'Failed to load members'

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Warning',
            icon: 'BellIcon',
            variant: 'warning',
            text: message,
          },
        })
      }
    },
    async getAllMembers() {
      return await this.$api.get('api/users/all')
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/pages/ui-feather.scss";

.table-custom-style {
  font-size: 13px !important;
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    //vertical-align: middle !important;
    text-align: left !important;
  }
}
.table-cell-margin {
  margin: 8px 0px;
}
.second-layer-margin {
  margin-top: 15px;
}

.required-label label::after {
  content: " *";
  color: red;
}
</style>
